import { ROUTES } from '@aibees/elephant/router';
import { createContext, useContext, useMemo } from 'react';
import { useLocation, useMatch } from 'react-router-dom';
import type { SearchTableScopeValue } from './types';

const SearchTableScopeContext = createContext<SearchTableScopeValue>(undefined);

const { Provider } = SearchTableScopeContext;

export { SearchTableScopeContext, Provider as SearchTableScopeProvider };

export const useSearchTableScope = () => useContext(SearchTableScopeContext);

/** Resolves scope from pathname: company search -> 'company', people search -> 'people', company employees -> 'employees' */
export function useSearchTableScopeFromRoute(): SearchTableScopeValue {
  const { pathname } = useLocation();
  const companyEmployeesMatch = useMatch(ROUTES.companyEmployees);
  return useMemo(() => {
    if (pathname.startsWith(ROUTES.searchCompany)) return 'company';
    if (pathname.startsWith(ROUTES.searchPeople)) return 'people';
    if (companyEmployeesMatch) return 'employees';
    return undefined;
  }, [pathname, companyEmployeesMatch]);
}
